import { useEffect, useState } from "react";
import { supplyCatalog, supplyEstimate, extractApiError } from "@/lib/api";

export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const COLLECTIONS = [
  ["graduation", "Graduation 2027"],
  ["executive", "Simply Social Executive Graduation Experiences"],
  ["birthday", "Children's Birthdays"],
];

let cached = null;
export const useSupplyCatalog = () => {
  const [cat, setCat] = useState(cached);
  useEffect(() => {
    if (!cached) supplyCatalog().then((c) => { cached = c; setCat(c); }).catch(() => {});
  }, []);
  return cat;
};

export const pricingText = (p) => {
  const r = p.pricing;
  if (r.type === "each") return `$${r.price} each`;
  if (r.type === "multiple") return `${r.set} for $${r.price}`;
  if (r.type === "tiers") return Object.entries(r.tiers).map(([q, v]) => `${q} for $${v}`).join(" · ");
  if (r.type === "base_plus") return Object.entries({ ...r.alone, ...r.bases }).map(([q, v]) => `${q} for $${v}`).concat(`+${r.step} for $${r.step_price}`).join(" · ");
  return `Starting at $${r.from}`;
};

export const useSupplyEstimate = (v) => {
  const [est, setEst] = useState(null);
  const [err, setErr] = useState("");
  const key = JSON.stringify([v.package, v.package_addons, v.package_2xl, v.items, v.fulfillment]);
  useEffect(() => {
    if (!v.package && !(v.items || []).length) { setEst(null); setErr(""); return; }
    const t = setTimeout(() => {
      supplyEstimate({ package: v.package, package_addons: v.package_addons, package_2xl: v.package_2xl || 0, items: v.items, fulfillment: v.fulfillment })
        .then((e) => { setEst(e); setErr(""); })
        .catch((e) => { setEst(null); setErr(extractApiError(e, "Please check your selection")); });
    }, 250);
    return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return { est, err };
};

const fmtDate = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric", year: "numeric" });

export const leadError = (est, neededBy, eventDate) => {
  if (!est) return "";
  const checks = est.executive_resource ? [["event date", eventDate]] : [["needed-by date", neededBy]];
  for (const [label, d] of checks) {
    if (!d) return `Please choose a ${label}.`;
    if (d < est.earliest_date) {
      return `This order requires at least ${est.lead_days} calendar days (${est.lead_reason}). The earliest eligible ${label} is ${fmtDate(est.earliest_date)}. Rush orders are not available.`;
    }
  }
  return "";
};
